class AgeGate {
  /**
   * Validate a user based on their age and province.
   *
   * @param {object} formValues Object of key-value pairs of all age-gate form fields.
   *
   * @returns {boolean} True if user clears the provincial/age requirements.
   */
  static checkValidation = (formValues) => {
    const dob = User.formatDOB(formValues.date, formValues.month, formValues.year);
    const age = User.calculateAge(dob);

    let isValid = false;

    if (age >= 19) {
      isValid = true;
    }

    return isValid;
  };

  /**
   * Conditional function to either:
   * a) Submit a valid user's form values for storage (and reload the page).
   * b) Or, show an error message to an invalid user.
   *
   * @param {jQuery} $form jQuery object of the age-gate form.
   *
   */
  static handleSubmit = ($form) => {
    const formValues = this.getFormValues($form);
    const isValid = this.checkValidation(formValues);

    if (isValid) {
      User.storeUser(formValues);
      location.reload();
    } else {
      showError(isValid);
    }
  };

  /**
   * Any/all UI changes based on form interactions.
   *
   * @param {jQuery} $form jQuery object of the age-gate form.
   *
   */
  static handleChange = ($form) => {
    const $dateOptions = $form.find('#age-gate-form-date option');
    const activeMonth  = $form.find('#age-gate-form-month').val();

    $dateOptions.each((i, el) => {
      const $el = $(el);
      if ($el.data('exclude-months')) {
        const excludedMonths = $el.data('exclude-months').toString().split(',');
        if(excludedMonths.includes(activeMonth)) {
          $el.hide().prop('disabled', true);
          if(true === $el.prop('selected')) {
            $dateOptions.filter(':not(:disabled)').last().prop('selected', true);
          }
        } else {
          $el.show().prop('disabled', false);
        }
      }
    })
  };

  /**
   * Creates an object of relevant values found in the from argument.
   *
   * @param {jQuery} $form jQuery object of the age-gate form.
   *
   * @returns {object} Form values from the age-gate form.
   */
  static getFormValues = ($form) => {
    const formObj = {
      province: $form.find('[name="province"]').val(),
      date: $form.find('[name="date"]').val(),
      month: $form.find('[name="month"]').val(),
      year: $form.find('[name="year"]').val(),
      remember: $form.find('[name="remember"]').prop('checked'),
    };

    return formObj;
  };
}

(($) => {
  $(() => {
    const $ageGateModal = $('#age-gate-modal');

    if ($ageGateModal.length) {
      const $ageGateForm = $ageGateModal.find('form');
      const $ageGateLockedOut = $ageGateModal.find('#age-gate-locked-out');
      const $ageGateContent = $ageGateModal.find('#age-gate-modal-content');
      const $ageGateBackBtn = $ageGateModal.find('#age-gate-back');

      // UI functions.
      const showError = () => {
        const formValues = AgeGate.getFormValues($ageGateForm);
        if (false === AgeGate.checkValidation(formValues)) {
          $ageGateContent.addClass('d-none');
          $ageGateLockedOut.removeClass('d-none');
        }
      };

      const showContent = () => {
        $ageGateLockedOut.addClass('d-none');
        $ageGateContent.removeClass('d-none');
      };

      // Events.
      $ageGateBackBtn.on('click', () => {
        showContent();
      });

      $ageGateModal.on('change', () => {
        AgeGate.handleChange($ageGateForm);
      });

      $ageGateModal.on('submit', (evt) => {
        evt.preventDefault();
        let formValues = AgeGate.getFormValues($ageGateForm);
        if (AgeGate.checkValidation(formValues)) {
          AgeGate.handleSubmit($ageGateForm);
        } else {
          showError();
        }
      });

      if (!User.isValid() && !Shopify.designMode) {
        $ageGateModal.modal('show');
      }
    }
  });
})(jQuery);
